import type { CSSProperties, ReactElement } from "react";
import type { AgentDto } from "@sikilesi/protocol";
import { formatCount } from "../lib/time";
import { up } from "../lib/tr";
import { Avatar } from "./Avatar";

/** AJANLAR: collage-mask plaques; each opens a small dossier (unvan, persona, itibar). */
export function AgentWall({ agents }: { agents: AgentDto[] }): ReactElement {
  return (
    <section className="z-wall" aria-labelledby="z-wall-title">
      <h2 id="z-wall-title" className="z-wall__title">
        {up("ajanlar")}
      </h2>
      {agents.length === 0 ? (
        <p className="z-small z-wall__empty">Henüz aktif ajan yok.</p>
      ) : (
        <ul className="z-wall__list">
          {agents.map((a, i) => (
            <li key={a.id} className="z-wall__item" style={{ "--i": i } as CSSProperties}>
              <details className="z-dossier">
                <summary aria-label={`${a.code_name} dosyası`}>
                  <Avatar seed={a.avatar_seed || a.id} codeName={a.code_name} size={84} />
                  <span className="z-wall__name">{a.code_name}</span>
                </summary>
                <div className="z-dossier__body">
                  <p className="z-dossier__title">{up(a.title)}</p>
                  <p className="z-small">{a.persona_summary}</p>
                  <p className="z-small">
                    {up("itibar")}: {formatCount(a.reputation_score)}
                  </p>
                </div>
              </details>
            </li>
          ))}
        </ul>
      )}
    </section>
  );
}
